import Image from 'next/image';
import SimpleReactLightbox, { SRLWrapper } from 'simple-react-lightbox';

import { useEffect, useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';

import { customLoader } from '../../../utils/customLoaderImage';
import { imagemSizes } from '../../../utils/ImageFindSizes';

import style from './galeryDesktopCarousel.module.scss';

export default function GaleryDesktopCarousel({ arrayItens }) {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadImages = async() => {
      if (!arrayItens || arrayItens.length === 0) {
        if (isMounted) setImagesLoaded(true);

        return;
      }

      await Promise.all(
        arrayItens.map(
          (item) => new Promise<void>((resolve) => {
            const img = new window.Image();

            img.src = item.imagem.url || '/img/image_icon.png';
            img.onload = () => resolve();
          }),
        ),
      );

      if (isMounted) setImagesLoaded(true);
    };

    loadImages();

    return () => {
      isMounted = false;
    };
  }, [arrayItens]);

  const options = {
    settings: {
      overlayColor: 'rgba(25,136,124,0.71)',
      autoplaySpeed: 3000,
      transitionSpeed: 900,
    },
    buttons: {
      showThumbnailsButton: false,
      showDownloadButton: false,
    },
    caption: {
      showCaption: false,
    },
    thumbnails: {
      showThumbnails: false,
    },
  };

  function ListaImg({ img, id }) {
    return (
      <a
        className={style.image}
        tabIndex={-1}>
        <figure tabIndex={-1}>
          <Image
            alt={img.imagem.titulo}
            objectFit='cover'
            src={imagemSizes(img) || '/img/image_icon.png'}
            loader={customLoader}
            width='480'
            height='480'
            priority
            tabIndex={-1}
            onLoadingComplete={() => {}}
          />
          <figcaption>
            Imagem: Foto
            {' '}
            {id}
            {' '}
            do empreendimento
            {' '}
            {img.imagem.titulo}
          </figcaption>
        </figure>
      </a>
    );
  }

  const seeMore = () => {
    setShowMore(!showMore);
  };

  return (
    <div className={style.gallery}>
      <SimpleReactLightbox>
        <SRLWrapper options={options}>
          <div
            id='containerImages'
            className={style.containerImages}>
            {!imagesLoaded && (
              <RotatingLines
                visible
                width='96'
                strokeColor='#00bd97'
                strokeWidth='5'
                animationDuration='1.5'
                ariaLabel='rotating-lines-loading'
              />
            )}
            {imagesLoaded && (
              <ul>
                {arrayItens.map((item, index) => (
                  <li
                    key={item.id}
                    style={{ display: index < 6 || showMore ? 'block' : 'none' }}>
                    <ListaImg
                      img={item}
                      id={item.id}
                    />
                  </li>
                ))}
              </ul>
            )}
            {imagesLoaded && arrayItens.length > 6 && (
              <button
                type='button'
                aria-label='Ver mais imagens'
                id='moreBtn'
                onClick={seeMore}
                className={style.moreBtn}>
                {showMore ? 'Ver menos' : 'Ver mais'}
              </button>
            )}
          </div>
        </SRLWrapper>
      </SimpleReactLightbox>
    </div>
  );
}
